@if (true) {
<div [ngClass]="component.section_width || ''">
    <div [ngClass]="[component.column_align || '']">
        @switch (component.type) {
        @default {
        <tag [tag]="component.tag || 'p'"
             [ngClass]="'w-' + component.content_width">
            <span class="w-12 text"
                  [ngClass]="[component.text_style || '', component.color || '', component.align || '']"
                  *iCms="'text' of component; content: 'html'"></span>
        </tag>
        }
        @case ('button') {
        <href [link]="component.cta_link">
            <button [ngClass]="[component.button_class || '']">
                <span class="button__body"
                      *iCms="'cta_label' of component">
                </span>
            </button>
        </href>

        }
        }
    </div>
</div>
}
